import React from "react";
import Button from "components/Button/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { NavLink } from "react-router-dom";

const EmptyUpcomingEvents = (props) => {
  return (
    <div>
      {/* Empty Upcoming Events Section Starts Here */}
      <div>
        <div className="empty-upcoming-events text-center">
          <Row>
            <Col md={12} lg={8} className="mx-auto">
              <div>
                <img
                  src={props.emptyEventImg}
                  alt="img"
                  className="img-fluid"
                />
                <h2>{props.noEventHeading}</h2>
                <p>{props.addCityHeading}</p>
                <p>{props.applyCityDescription}</p>
                <NavLink to="/hostevent">
                  <Button
                    theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 get-ticket"
                    style={{ width: "auto" }}
                  >
                    Apply Here
                  </Button>
                </NavLink>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      {/* Empty Upcoming Events Section Ends Here */}
    </div>
  );
};

export default EmptyUpcomingEvents;
